module.exports = __webpack_public_path__ + "media/images/digivent/logo-Mostra-transparente-e2dc92e8c734209cd553e10de79b685e.png";